import React, { useContext, useEffect, useRef, useState } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { NewInterview } from "../classes/new_interview_class";
import { EducationFormContext } from "../hooks/EducationFormContext";

export const EducationSelector: React.FunctionComponent = () => {
  const { t, uuid, profileInterviews } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(EducationFormContext);
  const [selectedLink, setSelectedLink] = useState(null);
  const [fullLinkSet, setFullLinkSet] = useState<any>();
  const dropDownRef = useRef<HTMLSelectElement>();

  useEffect(() => {
    window.addEventListener("click", function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
  }, []);

  const buildAvailableLinkSet = () => {
    var availableLinkSet = [];
    if (goalState.selectedInterview != null) {
      goalState.selectedInterview.stepLinks.map((link) => {
        if (!goalState.selectedEducationLinks.includes(link)) {
          availableLinkSet.push(link);
        }
      });
    }
    return availableLinkSet;
  };

  const handleAddSelection = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let revisedSelectionList = goalState.selectedEducationLinks;
    if (selectedLink != null) {
      revisedSelectionList.push(selectedLink);
    }
    setGoalState({
      ...goalState,
      selectedEducationLinks: revisedSelectionList,
    });
    setSelectedLink(null);
    dropDownRef.current.value = "";
  };

  useEffect(() => {
    let availableLinkSet = profileInterviews.map((id) => {
      let interview = NewInterview.find_by_id(id);
      return interview.stepLinks;
    });

    let flattenedSet = availableLinkSet.flat();

    setFullLinkSet(flattenedSet);
  }, [profileInterviews]);

  useEffect(() => {
    if (!fullLinkSet) return;

    let remainingEducationLinks = goalState.selectedEducationLinks.filter(
      (link) => fullLinkSet.find((i) => i == link)
    );
    if (remainingEducationLinks != goalState.selectedEducationLinks) {
      setGoalState({
        ...goalState,
        selectedEducationLinks: remainingEducationLinks,
      });
    }

    if (
      goalState.selectedInterview != null &&
      !profileInterviews.find((id) => id == goalState.selectedInterview.id)
    ) {
      buildAvailableLinkSet();
      let ii = NewInterview.find_by_id(profileInterviews[0]);
      setGoalState({
        ...goalState,
        selectedInterview: null,
      });
    }
  }, [fullLinkSet]);

  const handleRemoveSelection = (removed, e = null) => {
    if (e) {
      e.preventDefault();
    }
    var newLinkSet = goalState.selectedEducationLinks.filter(
      (link) => link != removed
    );
    setGoalState({
      ...goalState,
      selectedEducationLinks: newLinkSet,
    });
  };

  const activeLinkDropdownList = buildAvailableLinkSet().map((link) => {
    return (
      <option key={uuid()} id={link.id.toString()} value={link.id.toString()}>
        {link.label}
      </option>
    );
  });

  const selectedEducationLinks = () => {
    if (goalState.selectedEducationLinks != null) {
      return profileInterviews.map((id) => {
        let interview = NewInterview.find_by_id(id);
        let associatedEducationLinks = goalState.selectedEducationLinks.filter(
          (link) => link.parentInterview == interview
        );
        if (associatedEducationLinks.length > 0) {
          return (
            <div key={uuid()} className="goal-form-input-row">
              <div className="interview-link-grouping">
                <div className="goal-input-area-title full-width">
                  {interview.name}
                </div>
                <div className="goal-title-input-wrap">
                  {associatedEducationLinks.map((link) => {
                    return (
                      <div key={uuid()} className="goal-form-input-row">
                        <div className="goal-display-field">
                          <span>{link.label}</span>
                        </div>
                        <div>
                          <button
                            className="interview-node-delete"
                            onClick={(e) => handleRemoveSelection(link, e)}
                          >
                            <i className="delete-icon icon-delete bottom-offset"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        }
      });
    }
  };

  const handleSelectedLink = (e) => {
    var selection = buildAvailableLinkSet().find(
      (link) => link.id == e.currentTarget.value
    );
    setSelectedLink(selection);
  };
  const educationContentDropdown = () => {
    return (
      <div className="goal-form-input-row">
        <select
          ref={dropDownRef}
          name="interview-select"
          id="goal-parent-interview-dropdown"
          className="goal-minimal-dropdown dropdown-feature-length"
          defaultValue=""
          onChange={(e) => {
            e.stopPropagation();
            handleSelectedLink(e);
          }}
        >
          {" "}
          <option disabled value="">
            {t("views.goals.headings.select")}
          </option>
          {activeLinkDropdownList}
        </select>
        <button
          onClick={handleAddSelection}
          style={{
            border: "none",
            display: selectedLink == null ? "none" : "block",
          }}
        >
          <i className="icon-add add-icon"></i>
        </button>
      </div>
    );
  };

  const noLinkNotice = () => {
    return (
      <div className="goal-form-input-row">
        {t("views.goals.contexts.no_links_available")}
      </div>
    );
  };

  return (
    <>
      {" "}
      <div className="goal-boxed-input-area">
        <div className="goal-form-input-row">
          <label
            htmlFor="education-interview-parent-dropdown"
            className="goal-input-area-title full-width"
          >
            {t("views.goals.headings.select_educational_content")}
          </label>
        </div>
        {buildAvailableLinkSet().length > 0
          ? educationContentDropdown()
          : noLinkNotice()}
        <div className="link-set">{selectedEducationLinks()}</div>
      </div>
    </>
  );
};
